<template>
    <div class="custom-sidebar">
        <template  v-for="(item,index) in navList">
            <div v-if="!item.show_hall || hall_id" @click="handleNavigator(item)"  :class="{'router-link-active':routeName == item.routeName}" class="custom-sidebar-item" :key="index">
                <img :src="routeName == item.routeName ? item.icon_selected : item.icon" alt="">
                <p>{{item.name}}</p>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "customSidebar",
    components: {},
    props: {

    },
    data() {
        return {
            routeName: '',
            navList:[
                {path:'/hall/${meeting_id}',routeName:'Hall',icon:require('@/assets/images/lnav1.png'),icon_selected:require('@/assets/images/lnav1_on.png'),name:"首页"},
                {path:'/area/${meeting_id}/${hall_id}',routeName:'Area',icon:require('@/assets/images/lnav7.png'),icon_selected:require('@/assets/images/lnav7_on.png'),name:"座位管理",show_hall:true},
                {path:'/person/${meeting_id}/${hall_id}',routeName:'Person',icon:require('@/assets/images/lnav2.png'),icon_selected:require('@/assets/images/lnav2_on.png'),name:"区域人员",show_hall:true},
                {path:'/searchseat/${meeting_id}',routeName:'Searchseat',icon:require('@/assets/images/lnav3.png'),icon_selected:require('@/assets/images/lnav3_on.png'),name:"座位查询",target:'_blank'},
                {path:'/setting/${meeting_id}',routeName:'Setting',icon:require('@/assets/images/lnav4.png'),icon_selected:require('@/assets/images/lnav4_on.png'),name:"其他设置"},
                {path:'/sms-list/${meeting_id}/${hall_id}',routeName:'SmsList',icon:require('@/assets/images/lnav8.png'),icon_selected:require('@/assets/images/lnav8_on.png'),name:"消息通知",show_hall:true},
                // {path:'/charts',icon:require('@/assets/images/lnav5.png'),icon_selected:require('@/assets/images/lnav5_on.png'),name:"数据统计"},
            ]
        }
    },
    watch:{
        '$route':{
            handler(newVal){
                this.routeName = newVal.name;
                this.hall_id = newVal.params.hall_id;
            },
            immediate: true,
        }
    },
    computed:{
        showNav(){
            if(this.path.indexOf('${hall_id}') != -1){
                return this.hall_id;
            }
            return true;
        }
    },
    methods: {

        //跳转
        handleNavigator(item){
            let { meeting_id,hall_id } = this.$route.params;
            let path = item.path.replace('${meeting_id}',meeting_id);
            path = hall_id ? path.replace('${hall_id}',hall_id) : path;
            if(item.target == '_blank'){
                const routeUrl = this.$router.resolve({
                    path,
                })
                window.open(routeUrl.href,'_blank')
            }else{
                this.$router.push({path})
            }
        }
    },
    mounted() {},
}
</script>

<style lang="less" scoped>
.custom-sidebar{
    height:100%;
    width: 80px;
    box-sizing: border-box;
    position: relative;
    background-color: #1b3863;
    overflow: hidden;
    &-item{
        display: block;
        text-align: center;
        color: #7191ff;
        font-size: 12px;
        padding: 15px 0;
        cursor: pointer;
        p{
            margin:5px 0 0 0;
        }
        &.router-link-active{
            color:#fff;
            background: url(~@/assets/images/nav-bar-active-bg.jpg) no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>